module.exports = __webpack_public_path__ + "img/qyzz1.60915cbc.png";